import { FORM_METHOD_TYPES } from "../../../../stateCommon/consts";
import { METHOD_TEMPLATES } from "../../../utils/consts";
import { getObjectJSONString } from "../../../utils/code";
import { getCgiDefaultParamsValue } from "../../../../common/schemaUtil";
export const init = options => {
  const {
    query,
    body
  } = getCgiDefaultParamsValue(options.collection, 'request');
  const info = {
    args: [],
    type: FORM_METHOD_TYPES.init,
    tpl: METHOD_TEMPLATES.any.init,
    params: {
      assign: [{
        key: 'query',
        code: getObjectJSONString(query)
      }, {
        key: 'body',
        code: getObjectJSONString(body)
      }, {
        key: 'data',
        code: '{}'
      }],
      invoke: [{
        args: [],
        method: 'request',
        enabled: false
      }]
    }
  };
  return info;
};
//# sourceMappingURL=init.js.map
